import { Entity } from 'engine/Entity';
import { ColliderFacet, ColliderType } from 'engine/facets/ColliderFacet';
import { StaticSpriteFacet } from 'engine/facets/StaticSpriteFacet';
import { create } from 'engine/lib/create';
import { PondSprite } from 'game/sprites/PondSprite';

export class PondEntity extends Entity {
  createFacets() {
    return [
      create(StaticSpriteFacet, { frame: PondSprite }),
      create(ColliderFacet, {
        type: ColliderType.Polygon,
        offset: [0, 0],
        points: [[1421, 701], [1286, 836], [465, 836], [322, 666], [811, 248], [1286, 250], [1421, 385]],
      }),
      create(ColliderFacet, {
        type: ColliderType.Polygon,
        offset: [0, 0],
        points: [[662, 135], [810, 248], [322, 666]],
      }),
      create(ColliderFacet, {
        type: ColliderType.Polygon,
        offset: [0, 0],
        points: [
          [135, 0], [527, 0], [662, 135], [322, 666], [135, 588], [0, 453], [0, 135],
        ],
      }),
      create(ColliderFacet, { type: ColliderType.Circle, radius: 135, offset: [0, 0] }),
      create(ColliderFacet, { type: ColliderType.Circle, radius: 135, offset: [392, 0] }),
      create(ColliderFacet, { type: ColliderType.Circle, radius: 135, offset: [1150, 249] }),
      create(ColliderFacet, { type: ColliderType.Circle, radius: 135, offset: [1150, 565] }),
      create(ColliderFacet, { type: ColliderType.Circle, radius: 135, offset: [330, 565] }),
      create(ColliderFacet, { type: ColliderType.Circle, radius: 135, offset: [0, 318] }),
    ];
  }
}
